









































import {Component, Prop, Watch} from "vue-property-decorator";
import AsiListTable from "@/components/common/AsiListTable.vue";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import CompanyListFilter from "@/models/company/CompanyListFilter";
import CompanyListEntry from "@/models/company/CompanyListEntry";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import {enumTextFromValue, enumToSelectItems} from "@/helpers/functions_asi";
import {CompanyState, CompanyType, Permissions} from "@/helpers/constants";
import AsiSelect from "@/components/common/AsiSelect";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import PaginatedResponse from "@/models/PaginatedResponse";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import CompanySimple from "@/models/company/CompanySimple";
import {Icon} from "@/helpers/icons";
import {getCompanyIcon} from "@/helpers/functions_td";

@Component({
	components: {
		AsiAvatar,
		AsiContentContainer,
		AsiSelectSimple,
		AsiListTableLayout, AsiSelect, AsiTextFieldSimple, AsiListTable
	}
})
export default class CompanyList extends AsiListTable<CompanyListEntry, CompanyListFilter> implements IAsiListTableImplementation<CompanyListEntry, CompanyListFilter> {

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;
	protected companyTypeOptions = enumToSelectItems(CompanyType, true);
	protected companyStateOptions = enumToSelectItems(CompanyState, true);
	private icons = Icon;

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	public mounted(): void {
		this.tableOptions.sortBy = ['name'];
		this.tableOptions.sortDesc = [false];
		this.reload();
	}

	public createFilterModel(): CompanyListFilter {
		return new CompanyListFilter();
	}

	public createHeaders(): AsiListTableHeader[] {
		return [
			new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'),
			new AsiListTableHeader(this.$t('company.name').toString(), 'name', true, true, 'start'),
			new AsiListTableHeader(this.$t('company.type').toString(), 'type', true, true, 'start', '8rem'),
		];
	}

	public fetchData(filterModel: CompanyListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<CompanyListEntry>> {
		return this.$companyService.companies(filterModel, tableOptions);
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(model: CompanyListEntry): void {
		this.$router.push({name: 'Company', params: {id: model.id}})
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	protected companyTypeIcon(type: CompanyType): string {
		return getCompanyIcon(type);
	}

	protected companyTypeLabel(type: CompanyType): string | null {
		return enumTextFromValue(CompanyType, type, true);
	}

	protected avatarUrl(companySimple: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(companySimple);
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
